import React, {useContext, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {Main, Notification} from '../../../patterns';
import {StoreContext} from '../base/root-store';
import {GenericError} from '../base/GenericError';

export const CompanyDeletedConfirmation = observer((): JSX.Element => {

    const store = useContext(StoreContext).companyDeleteStore;

    useEffect(() => {
        store.onEnter();

    }, []);
    const state = store.state;
    const errorReason = store.errorReason;

    if (state === 'error' && errorReason === 'invalid-token') {
        return <Main showBackground={true}>
            <Notification
                text={store.labelStore.label('link.expired.title')}
                defaultIsOpen={true}
                type="info"
            />
        </Main>;
    } else if (state === 'error' && errorReason === 'generic') {
        return <GenericError/>;
    } else if (state === 'deleted' || state === undefined) {
        return <Main showBackground={true}>
            <Notification
                text={store.labelStore.label('organization.deleted.title')}
                defaultIsOpen={true}
                type="info"
            />
        </Main>;
    } else {
        return <></>;
    }
},
);
